import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

// Firebase configuration - Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCPxTX6uAgHE3DqFCu8Qo03wXy434MVSv4",
  authDomain: "stakealertsauth.firebaseapp.com",
  projectId: "stakealertsauth",
  storageBucket: "stakealertsauth.firebasestorage.app",
  messagingSenderId: "183640740103",
  appId: "1:183640740103:web:4127dbd4c0ee94ac3875a2",
  measurementId: "G-LYYQQ4P78H",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

// Configure Google provider scopes
googleProvider.addScope("profile");
googleProvider.addScope("email");

// Configure Apple provider scopes
appleProvider.addScope("email");
appleProvider.addScope("name");
